// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";
import { TypeFilterObject } from "@hex-insights/core";
import {
	AnnouncementSelectField,
	CalendarEventSelectField,
	CourseAssessmentSelectField,
	CourseAssessmentSubmissionSelectField,
	MessageSelectField,
	PersonSelectField,
	PostSelectField,
	SocialCommentSelectField,
	SocialReactionSelectField,
	StudentMedicalEventSelectField,
	StudentNoteSelectField,
} from "../../Forms";
import { registry } from "../registry";
import * as CustomFilterFormValues from "./form-values-custom";

export type FilterFormValues = CustomFilterFormValues.StandardFilterFormValues &
	IndexForms.SearchFormValues &
	IndexForms.FilterFormValues;

export const initial: FilterFormValues = {
	...CustomFilterFormValues.initialStandardFilters,
	...IndexForms.initialSearchFormValues,
	...IndexForms.initialFilterFormValues,
};

export function getInitial(initialFormValues?: Partial<FilterFormValues>): FilterFormValues {
	return { ...initial, ...initialFormValues };
}

export const typeFilterObject: TypeFilterObject<FilterFormValues> = {
	...CustomFilterFormValues.standardFiltersTypeFilterObject,
	...IndexForms.searchFormValuesFilterObject,
	...IndexForms.filterFormValuesFilterObject,
};

export const advancedFilterInformation: IndexForms.AdvancedFilterInformation = {
	fieldOptions: [
		{ value: "displayOrder" },
		{ value: "title" },
		{ value: "description" },
		{ value: "linkURL" },
		{ value: "announcement" },
		{ value: "calendarEvent" },
		{ value: "courseAssessment" },
		{ value: "courseAssessmentSubmission" },
		{ value: "message" },
		{ value: "post" },
		{ value: "socialComments" },
		{ value: "socialReactions" },
		{ value: "studentMedicalEvent" },
		{ value: "studentNote" },
		{ value: "taggedPeople" },
	],
	fieldComparisonOptions: {
		displayOrder: IndexForms.numberComparisonOptions,
		title: IndexForms.stringComparisonOptions,
		description: IndexForms.stringComparisonOptions,
		linkURL: IndexForms.stringComparisonOptions,
		announcement: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		calendarEvent: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		courseAssessment: [
			...IndexForms.singularEdgeComparisonOptions,
			...IndexForms.nullableSingularEdgeComparisonOptions,
		],
		courseAssessmentSubmission: [
			...IndexForms.singularEdgeComparisonOptions,
			...IndexForms.nullableSingularEdgeComparisonOptions,
		],
		message: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		post: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		socialComments: IndexForms.multipleEdgeComparisonOptions,
		socialReactions: IndexForms.multipleEdgeComparisonOptions,
		studentMedicalEvent: [
			...IndexForms.singularEdgeComparisonOptions,
			...IndexForms.nullableSingularEdgeComparisonOptions,
		],
		studentNote: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		taggedPeople: IndexForms.multipleEdgeComparisonOptions,
	},
	fieldComparisonTranslations: {
		displayOrder: IndexForms.numberComparisonTranslations,
		title: IndexForms.stringComparisonTranslations,
		description: IndexForms.stringComparisonTranslations,
		linkURL: IndexForms.stringComparisonTranslations,
		announcement: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				AnnouncementSelectField.Select,
				AnnouncementSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		calendarEvent: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				CalendarEventSelectField.Select,
				CalendarEventSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		courseAssessment: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				CourseAssessmentSelectField.Select,
				CourseAssessmentSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		courseAssessmentSubmission: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				CourseAssessmentSubmissionSelectField.Select,
				CourseAssessmentSubmissionSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		message: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				MessageSelectField.Select,
				MessageSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		post: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				PostSelectField.Select,
				PostSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		socialComments: IndexForms.getMultipleEdgeComparisonTranslations(
			SocialCommentSelectField.Select,
			SocialCommentSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		socialReactions: IndexForms.getMultipleEdgeComparisonTranslations(
			SocialReactionSelectField.Select,
			SocialReactionSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		studentMedicalEvent: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				StudentMedicalEventSelectField.Select,
				StudentMedicalEventSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		studentNote: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				StudentNoteSelectField.Select,
				StudentNoteSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		taggedPeople: IndexForms.getMultipleEdgeComparisonTranslations(
			PersonSelectField.Select,
			PersonSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
	},
};

registry.register("MediaAttachment", advancedFilterInformation, {
	announcement: "Announcement",
	calendarEvent: "CalendarEvent",
	courseAssessment: "CourseAssessment",
	courseAssessmentSubmission: "CourseAssessmentSubmission",
	message: "Message",
	post: "Post",
	socialComments: "SocialComment",
	socialReactions: "SocialReaction",
	studentMedicalEvent: "StudentMedicalEvent",
	studentNote: "StudentNote",
	taggedPeople: "Person",
});
